/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type COMMENT_STATUS = "APPROVED" | "NONE" | "PREMOD" | "REJECTED" | "SYSTEM_WITHHELD" | "%future added value";
export type IllegalContentReportViewContainer_comment = {
    readonly id: string;
    readonly status: COMMENT_STATUS;
    readonly revision: {
        readonly id: string;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"RejectedTombstoneContainer_comment" | "IgnoredTombstoneOrHideContainer_comment" | "DeletedTombstoneContainer_comment" | "CommentContainer_comment">;
    readonly " $refType": "IllegalContentReportViewContainer_comment";
};
export type IllegalContentReportViewContainer_comment$data = IllegalContentReportViewContainer_comment;
export type IllegalContentReportViewContainer_comment$key = {
    readonly " $data"?: IllegalContentReportViewContainer_comment$data;
    readonly " $fragmentRefs": FragmentRefs<"IllegalContentReportViewContainer_comment">;
};



const node: ReaderFragment = (function () {
    var v0 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any);
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": null,
        "name": "IllegalContentReportViewContainer_comment",
        "selections": [
            (v0 /*: any*/),
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "status",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "CommentRevision",
                "kind": "LinkedField",
                "name": "revision",
                "plural": false,
                "selections": [
                    (v0 /*: any*/)
                ],
                "storageKey": null
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "RejectedTombstoneContainer_comment"
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "IgnoredTombstoneOrHideContainer_comment"
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "DeletedTombstoneContainer_comment"
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "CommentContainer_comment"
            }
        ],
        "type": "Comment",
        "abstractKey": null
    } as any;
})();
(node as any).hash = 'c5ecdb2b2dc6940846bc8ddcb8d57c8d';
export default node;
